module.exports = __webpack_public_path__ + "cement/img/组 97.5653b48a.png";